import { render, staticRenderFns } from "./PreviewTitle.vue?vue&type=template&id=4fcd74cc&scoped=true"
import script from "./PreviewTitle.vue?vue&type=script&lang=js"
export * from "./PreviewTitle.vue?vue&type=script&lang=js"
import style0 from "./PreviewTitle.vue?vue&type=style&index=0&id=4fcd74cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd74cc",
  null
  
)

export default component.exports